// extracted by mini-css-extract-plugin
export default {"containerAbsolute":"ScrollIndicator_containerAbsolute__3BZZx","containerRelative":"ScrollIndicator_containerRelative__Tzin5"};